import {
  OverflowDataViewAction,
  ButtonDataViewAction,
  CustomDataViewButton,
} from 'analysis-tool/data-view/DataViewContext';
import {AnalysisRightSidebarItem} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisMainViewItem} from 'analysis-tool/ui/main-view/MainViewTypes';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';

import getAddViewAction from './getAddViewAction';
import getCopyViewAction from './getCopyViewAction';
import getDeleteViewAction from './getDeleteViewAction';
import getEditSourceStepAction from './getEditSourceStepAction';
import getEditViewAction from './getEditViewAction';
import getFlaggingActions from './getFlaggingActions';
import getPromoteViewAction from './getPromoteViewAction';
import getReplaceSourceAction from './getReplaceSourceAction';
import getRerunStepAction from './getRerunStepAction';

export default function getAnalysisDataViewActions(
  analysis: PipelineGraphQL,
  analysisClientStateId: string,
  view: PipelineViewGraphQL,
  viewStepId: string,
  selectedRowIndices: Set<number>,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void,
  selectedRightSidebarItem: AnalysisRightSidebarItem | null,
  analysisPromoteViewEnabled: boolean,
  isConsolidatedAddSourceEnabled: boolean
): {
  buttonActions: Array<ButtonDataViewAction | CustomDataViewButton>;
  overflowActions: Array<OverflowDataViewAction>;
} {
  return {
    buttonActions: [
      getRerunStepAction(analysis, view),
      ...getFlaggingActions(analysis, view, viewStepId, selectedRowIndices),
      getAddViewAction(analysis, view, onChangeSelectedItem, onChangeSelectedRightSidebarItem),
      getEditViewAction(
        analysis,
        view,
        onChangeSelectedItem,
        onChangeSelectedRightSidebarItem,
        selectedRightSidebarItem
      ),
    ].filter((action) => action != null),
    overflowActions: [
      getEditSourceStepAction(analysis, view, onChangeSelectedRightSidebarItem),
      getReplaceSourceAction(
        analysis,
        view,
        onChangeSelectedItem,
        onChangeSelectedRightSidebarItem,
        isConsolidatedAddSourceEnabled
      ),
      getCopyViewAction(analysis, view),
      analysisPromoteViewEnabled ? getPromoteViewAction(analysis, view) : null,
      getDeleteViewAction(analysis, view, analysisClientStateId),
    ].filter((action) => action != null),
  };
}
